import { roundFloat } from "../../utils/round-float";
import { Troop } from "../types";

const getTroopPrice = (troop: Troop) => troop.level ? +roundFloat(+troop.clegCost * Math.pow(2, +troop.level - 1)) : 0;

export default getTroopPrice;